import { render, staticRenderFns } from "./DashboardGraph.vue?vue&type=template&id=fa2acc0a&scoped=true"
import script from "./DashboardGraph.vue?vue&type=script&lang=js"
export * from "./DashboardGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2acc0a",
  null
  
)

export default component.exports